import { graphql, useStaticQuery } from "gatsby"
import { TNavigation } from "../types"

const footerColumnOne = (): TNavigation => {

  const query = useStaticQuery(
    graphql`
      query {
        allNavigation(filter: { title: { eq: "Footer Column 1" } }) {
          nodes {
            title
            json
          }
        }
      }
    `)

  return query.allNavigation.nodes[0]

}

export default footerColumnOne
